import { RenderModalCtx } from 'datocms-plugin-sdk';
import { Button, Canvas } from 'datocms-react-ui';
import { APIError, GraphQLClient, GraphQLResponseError, UseQueryResult, useQuery } from "graphql-hooks";
import useGQLQueryWithClient, { useMultipleGQLQueryWithClient } from '../hooks/useGQLQueryWithClient';
import { StructuredText } from 'react-datocms/structured-text';
import { useState } from 'react';
import { RenderStoryCard } from './RenderStoryCard';
import './RenderStory.css';
import { RenderTitleCard } from './RenderTitleCard';

type PropTypes = {
  ctx: RenderModalCtx;
};

function getStoryCard(id: string, locale : string) {
  return `
  query storyCard {
    storyCard(
      filter: {
        id: {eq: "${id}"}
      }
    ) {
        id
        image {
          url
        }
        backgroundImage {
          url
        }
        textAfterImage(locale: ${locale}) {
          value
        }
        textBeforeImage(locale: ${locale}) {
          value
        }
      }
    }
  `;
}

function getStoryTitleImage(id: string): string {
  return `
  query StoryTitleImage {
    story(
      filter: {
        id: {eq: "${id}"}
      })
    {
      titleImage {
        url
      }
    }
  }
  `;
};



type StoryContent = {
  internalLocales: Array<string>,
  "card_image": {
    "alt": string,
    "title": string,
    "custom_data": any,
    "focal_point": string,
    "upload_id": string
  },
  "card_text": { [key: string]: string | null },
  "title_image": {
    "alt": string,
    "title": string,
    "custom_data": any,
    "focal_point": string,
    "upload_id": string
  },
  "title": { [key: string]: string | null },
  "story_cards": Array<string>,
  "button_text": { [key: string]: string | null },
  "button_text_color": {
    "red": number,
    "blue": number,
    "alpha": number,
    "green": number
  },
  "button_background_color": {
    "red": number,
    "blue": number,
    "alpha": number,
    "green": number
  },
  "button_action": string,
  "text_color": {
    "red": number,
    "blue": number,
    "alpha": number,
    "green": number
  },
  "tags": string
}

function RenderStory({ ctx }: PropTypes) {
  const width = ctx.parameters.width as number;
  const height = ctx.parameters.height as number;
  const storyContent = ctx.parameters.cardContent as StoryContent;
  const cardIds = storyContent.story_cards as string[];
  const id = ctx.parameters.id as string;
  const locale = ctx.parameters.locale as string;

  console.log(storyContent)

  const client = new GraphQLClient({
    url: "https://graphql.datocms.com/",
    headers: {
      "Authorization": `Bearer c2637bf4c3ca322961249cf1b65310`, // Todo use user token
      "X-Include-Drafts": "true",
    }
  });

  const [currentCard, setCurrentCard] = useState<number>(0);
  const { loading, error, data: cards } = useMultipleGQLQueryWithClient(client, cardIds.map((id) => getStoryCard(id, locale)));
  const { loading: loadingImgUrl, error: errorImgUrl, data: titleImgUrl} = useGQLQueryWithClient(client, getStoryTitleImage(id));

  
  if (loading || loadingImgUrl) return <div>"Loading..."</div>;
  if (error || errorImgUrl) return <div>"Error..."</div>;
  
  const titleImageUrl = ((titleImgUrl.data as any)?.story?.titleImage?.url ?? "") as string ;
  console.log("story id: ",id,  "titleImageUrl: ", (titleImgUrl.data as any)?.story);

  return (
    <Canvas ctx={ctx}>
      <div style={{ fontSize: 'var(--font-size-xxxl)', fontWeight: '500' }}>
        <div className="buttonContainer">
          <Button onClick={() => setCurrentCard((c) => {
            if (c <= 0) return 0;
            return c - 1;
          })}>Left</Button>
          <Button onClick={() => setCurrentCard((c) => {
            if (c >= cards.length) return cards.length;
            return c + 1;
          })}>Right</Button>
        </div>
        <div className="phoneSimulatorContainer">
          <div className="smartphoneBorder" style={{ "width": `${width}px`, "height": `${height}px` }}>
          {(currentCard === 0)?
            (<RenderTitleCard backgroundImgUrl={titleImageUrl} title={storyContent.title[locale] ?? "Missing"} />)
            :
            (<RenderStoryCard data={cards[currentCard-1]}/>)
          }
          </div>
        </div>

      </div>
    </Canvas>
  );
}

//<RenderTitleCard backgroundImgUrl='www.googwedewle.com' title={storyContent.title['en'] ?? "Missing"} />
//<RenderStoryCard data={cards[currentCard]}/>
export default RenderStory;